import type { CaseInfo } from '../types';
import type { SeasonInfo } from '../types/season';

// Constant value for # of episodes in a season
export const TOTAL_EPISODE_SLOTS = 12;

/**
 * Filters cases to only include those that belong to a season
 * Cases without a seasonId are excluded from the discover page
 */
export const filterSeasonCases = (cases: CaseInfo[]): CaseInfo[] => {
  return cases.filter((c) => c.seasonId != null);
};

/**
 * Sorts cases by season number first, then by episode number within each season
 * Cases without season data are sorted to the end
 */
export const sortCasesBySeasonAndEpisode = (
  cases: CaseInfo[],
  seasons: SeasonInfo[],
): CaseInfo[] => {
  const seasonOrderMap = new Map<string, number>();
  seasons.forEach((s) => {
    seasonOrderMap.set(s.seasonId, s.seasonNumber);
  });

  return [...cases].sort((a, b) => {
    const seasonNumA = a.seasonId
      ? (seasonOrderMap.get(a.seasonId) ?? 999)
      : 999;
    const seasonNumB = b.seasonId
      ? (seasonOrderMap.get(b.seasonId) ?? 999)
      : 999;
    if (seasonNumA !== seasonNumB) return seasonNumA - seasonNumB;
    return (a.episodeNumber ?? 0) - (b.episodeNumber ?? 0);
  });
};

/**
 * Finds the index of a case by its caseId
 * Returns -1 if not found
 */
export const findCaseIndexById = (
  cases: CaseInfo[],
  caseId: string,
): number => {
  return cases.findIndex((c) => c.caseId === caseId);
};
